<button
  pButton
  [class]="styleClass"
  [ngClass]="{
    'border-0': disabled || !styleClass.includes('p-button-outlined')
  }"
  style="padding-top: 0 !important; padding-bottom: 0 !important; padding-right: 0.5rem !important"
  [disabled]="disabled"
  (click)="press.emit($event)">
  <i
    *ngIf="icon"
    class="p-button-icon p-button-icon-left text-sm"
    [class]="icon"
    [ngClass]="{
      'text-white': !disabled && !styleClass.includes('p-button-outlined'),
      'text-gray-600': disabled,
      'text-primary-400': styleClass.includes('p-button-outlined') && !disabled
    }"></i>
  <span>{{ label }}</span>
  <div
    class="mr-2 ml-4 h-full"
    style="width: 1px"
    [ngClass]="{
      'bg-primary-300': !disabled,
      'bg-gray-200': disabled
    }"></div>
  <i
    class="p-button-icon fa-regular fa-chevron-down text-sm"
    style="margin-right: 0 !important"
    [ngClass]="{
      'text-white': !disabled && !styleClass.includes('p-button-outlined'),
      'text-gray-600': disabled,
      'text-primary-400': styleClass.includes('p-button-outlined') && !disabled
    }"></i>
</button>
